import { Label } from "../../../components/Label";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Icon } from "../../../components/core/Icon";
import { NumberInput } from "../../../components/NumberInput";
import { If } from "../../../components/control-statements/If";
import * as uuid from 'uuid';

const SizeItem = ({ mode, size, sizeLength, onDeleteSize, onChange }) => {
	return (
		<>
			<div className="d-flex mb-15">
				<Input
					design="four"
					floatLabel="Nome do tamanho"
					defaultValue={size.name}
					onChange={(e) => {
						onChange && onChange({ ...size, name: e.target.value })
					}}
					className="w-100"
				/>
				<If cond={mode === 'pizza'}>
					<NumberInput
						design="four"
						precision={0}
						value={size.max || null}
						placeholder="Máx. sabores"
						onChange={(e, m, f) => {
							onChange && onChange({ ...size, max: f })
						}}
						className="ml-15 w-50"
					/>
				</If>
				<If cond={sizeLength > 2}>
					<Button
						design="default-icon-2"
						onClick={() => onDeleteSize && onDeleteSize(size)}
						className="ml-15"
					>
						<Icon name="trash-alt" size="lg" />
					</Button>
				</If>
			</div>
		</>
	)
}

const SetSizesStep = ({ category, onChange }) => {

	const handler = (sizes) => {
		onChange && onChange({ ...category, sizes })
	}

	return (
		<>
			{category.sizes.length === 1 && category.mode === "pizza" && (
				<>
					<Label>Informe o máximo de sabores</Label>
					<Input 
						design="four" 
						floatLabel="Máx. sabores" 
						onChange={(e) => {
							handler([{ ...category.sizes[0], max: e.target.value }])
						}} 
					/>
				</>
			)}

			{category.sizes.length > 1 && (
				<>
					<Label>Quais são os tamanhos?</Label>
					{
						category.sizes.map((size, sizeIdx, sizes) => {
							return (
								<SizeItem
									key={size.ref_id}
									size={size}
									mode={category.mode}
									sizeLength={category.sizes.length}
									onChange={(size) => {
										sizes[sizeIdx] = size;
										handler(sizes);
									}}
									onDeleteSize={() => handler(sizes.filter((s) => s.ref_id != size.ref_id))}
								/>
							)
						})
					}
					{category.sizes.length > 1 && (
						<Button design="default-2" className="mt-5" onClick={() => handler([...category.sizes, { name: "", type: 'size', ref_id: uuid.v4() }])}>
							Adicionar tamanho
						</Button>
					)}
				</>
			)}
		</>
	);
};

export default SetSizesStep;
